import AntSynSymbol from "./AntSynSymbol";
import { VocaMeaningLine } from "./VocaCardFront";
import "./VocaCardBack.css";

// 이 길이부터는 폰의 좁은 단어 칸에 한 줄로 안 들어가 글자를 줄인다.
const LONG_WORD_LENGTH = 10;

const VocaCardBack = ({ currentPage }) => {
  return (
    <div className="voca-card-back">
      <div className="voca-card-back__row">
        <div className="voca-card-back__word-cell">
          <div
            className={`voca-card-back__word${currentPage.word.length >= LONG_WORD_LENGTH ? " voca-card-back__word--long" : ""}`}
            lang="en"
          >
            {currentPage.word}
          </div>
          <div className="voca-card-back__pron">
            {currentPage.pron}
          </div>
          {currentPage.syn && (
            <div className="voca-card-back__relation">
              <AntSynSymbol type="syn" />
              <div>
                {currentPage.syn.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
          {currentPage.ant && (
            <div className="voca-card-back__relation">
              <AntSynSymbol type="ant" />
              <div>
                {currentPage.ant.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="voca-card-back__meaning-cell">
          {currentPage.kor.split("\n").map((line, index) => (
            <VocaMeaningLine key={index} line={line} />
          ))}
          {currentPage.eng && (
            <div className="voca-card-back__english" lang="en">
              {currentPage.eng.split("\n").map((line, index) => (
                <VocaMeaningLine key={index} line={line} />
              ))}
            </div>
          )}
        </div>
      </div>
      {currentPage.example && (
        <div className="voca-card-back__example">
          {currentPage.example_list.map((line, exampleIndex) => (
            <div key={exampleIndex} className="voca-card-back__sentence">
              <div lang="en">
                {line
                  .split(/(\{.*?\})/g)
                  .map((part, index) =>
                    part.startsWith("{") && part.endsWith("}") ? (
                      <strong key={index}>{part.slice(1, -1)}</strong>
                    ) : (
                      part
                    )
                  )}
              </div>
              <div className="voca-card-back__translation">{currentPage.example_translation_list[exampleIndex]}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VocaCardBack;
